import PartnerList from "../components/PartnerList";

const ListPartnerPage = () => {
  return (
    <PartnerList />
  );
};

export default ListPartnerPage;
